/** @format */

import React from 'react';
import {
  Grid,
  Button,
  Typography,
  CardActions,
  Card,
  CardContent,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useStyles } from './style';
import { buildURL } from 'utility/util';
import { getDynamicObjectAction } from 'utility';
import { Icons, TableItemActionsNew } from 'components';
export default function Key({ id, fullName, username, image, userId }) {
  // --STATES--//
  const [anchorEl, setAnchorEl] = React.useState(null);
  const actionsList =
    getDynamicObjectAction([
      'followersListTransferFinancialBtn',
      'followersListInvoicesFinancialBtn',
      'followersListInvoiceFinancialBtn',
      'followersListCreditVoucherFinancialBtn',
      'followersListVoucherFinancialBtn'

    ])
  // --HOOKS--//
  const classes = useStyles();
  const navigate = useNavigate();

  // --API--//

  // -- LOCAL VARIABLES --//

  // -- OTHER FUNCTIONS--//

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const redirecTo = (dest = 'CREATE_VOUCHER') => {
    // CREATE_VOUCHER or CREATE_CREDIT_VOUCHER or FACTORS or TRANSFER_CREDIT
    const userInfo = {
      image: image ? btoa(image) : null,
      username: username ?? null,
      fullName: fullName ?? null,
      userId: userId ?? null,
    };
    let query = {};
    let url = '';
    switch (dest) {
      case 'CREATE_VOUCHER':
        url = '/Voucher/AddVoucher';
        query = { ...userInfo };
        break;
      case 'CREATE_CREDIT_VOUCHER':
        url = '/Voucher/AddCreditVoucher';
        query = { ...userInfo };
        break;
      case 'FACTORS':
        url = '/Invoice';
        query = { ...userInfo };
        break;
      case 'ISSUE_INVOICE':
        url = '/IssueInvoice';
        query = { ...userInfo };
        break;
      case 'TRANSFER_CREDIT':
        url = '/TransferToCustomer';
        query = {
          ...userInfo,
          userInfoType: 'username',
          userInfo: userInfo?.username,
        };
        break;
      default:
        return;
    }

    navigate(buildURL(url, query));
  };


  return (
    <Card xs={12} className={classes.root}>
      <CardContent className={classes.content}>
        <Grid container justifyContent="space-between" alignItems="flex-start">
          <Grid item>
            {image ? (
              <img
                alt={fullName}
                src={image}
                className={classes.profileImage}
              />
            ) : (
              <span className={classes.avatarDefault}>
                <Icons icon="user" color="#ccd1f0" size="30" />
              </span>
            )}
          </Grid>
          <Grid item className={classes.titlePart} xs>
            <Typography variant="h5" className={classes.titleText}>
              {username ?? '-'}
            </Typography>
            <Typography variant="h6" className={classes.subtitleText}>
              {fullName ?? '-'}
            </Typography>
            <Typography variant="h6" className={classes.subestTitleText}>
              شناسه:‌ {id ?? '-'}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions className={classes.actionButtons}>
        <Grid container>
          {/* TODO: Reform it */}

          {actionsList['followersListTransferFinancialBtn'] && (
            <Button
              onClick={() => redirecTo('TRANSFER_CREDIT')}
              size="small"
              className={classes.actionButton}
            >
              انتقال وجه
            </Button>
          )}

          {actionsList['followersListInvoiceFinancialBtn'] && (
            <Button
              onClick={() => redirecTo('ISSUE_INVOICE')}
              size="small"
              className={classes.actionButton}
            >
              صدور فاکتور
            </Button>
          )}

          {actionsList['followersListInvoicesFinancialBtn'] && (
            <Button
              onClick={() => redirecTo('FACTORS')}
              size="small"
              className={classes.actionButton}
            >
              فاکتورهای مشتری
            </Button>
          )}


          {/* Other Actions */}
          <div className={classes.otherActions}>
            {(actionsList['followersListVoucherFinancialBtn'] || actionsList['followersListCreditVoucherFinancialBtn']) &&

              <TableItemActionsNew
                iconButton
                startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
                title=""
                otherMenus={[
                  {
                    title: 'بن تخفیف',
                    isShow: !!actionsList['followersListVoucherFinancialBtn'],
                    onClick: () => redirecTo('CREATE_VOUCHER'),
                  },
                  {
                    title: 'بن شارژ',
                    isShow: !!actionsList['followersListCreditVoucherFinancialBtn'],
                    onClick: () => redirecTo('CREATE_CREDIT_VOUCHER'),
                  },
                ]}
              />
            }

          </div>
        </Grid>
      </CardActions>
    </Card>
  );
}




